import { Box, Typography, Grid } from "@mui/material";

interface ZoneInvolucratedContProps {
  titlePrincipal: string
  titleItem1: string
  captionitem1: string
  titleItem2: string
  captionitem2: string
  titleItem3: string
  captionitem3: string
  titleitem4?: string
  captionitem4?: string
}

export const ZoneInvolucratedCont = (ZoneInvolucratedContProps: ZoneInvolucratedContProps) => {
  return (
    <Box sx={{ backgroundColor: "#FAFAFA" }}>
      <Box sx={{ p: 2 }}>
        <Typography variant="h6">
          {ZoneInvolucratedContProps.titlePrincipal}
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <Typography variant="body2" color="textSecondary" sx={{ fontWeight: "bold" }} >
              {ZoneInvolucratedContProps.titleItem1}
            </Typography>
            <Typography variant="footer">
              {ZoneInvolucratedContProps.captionitem1}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="body2" color="textSecondary" sx={{ fontWeight: "bold" }}>
              {ZoneInvolucratedContProps.titleItem2}
            </Typography>
            <Typography variant="footer">
              {ZoneInvolucratedContProps.captionitem2}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={ZoneInvolucratedContProps.titleitem4 ? 6 : 12}>
            <Typography variant="body2" color="textSecondary" sx={{ fontWeight: "bold" }} >
              {ZoneInvolucratedContProps.titleItem3}
            </Typography>
            <Typography variant="footer">
              {ZoneInvolucratedContProps.captionitem3}
            </Typography>
          </Grid>
          {ZoneInvolucratedContProps.titleitem4 && (
            <Grid item xs={12} sm={6}>
              <Typography variant="body2" color="textSecondary" sx={{ fontWeight: "bold" }} >
                {ZoneInvolucratedContProps.titleitem4}
              </Typography>
              <Typography variant="footer">
                {ZoneInvolucratedContProps.captionitem4}
              </Typography>
            </Grid>
          )}
        </Grid>
      </Box>
    </Box>
  );
};